import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

// TODO: padronizar 'apontamentoHeaderReport' para remover este arquivo.
export default function HeaderReport(visita, indicador, apontamento, params, optLabelConformidade) {
    // pdf do laudo, ou melhor, pdf da visita
    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;
    if (!params) {
        return null;
    }

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;
    const statusDespontePerdas = IndicadorClass.getConformidadeStatus(
        apontamento.despontePerdas,
        params.despontePerdas,
    );
    const statusDesponteNaoDespontada = IndicadorClass.getConformidadeStatus(
        apontamento.desponteNaoDespontada,
        params.desponteNaoDespontada,
    );
    const statusGemasDanificadasFacao = IndicadorClass.getConformidadeStatus(
        apontamento.gemasDanificadasFacao,
        params.gemasDanificadasFacao,
    );
    const statusGemasDanificadasPragaClima = IndicadorClass.getConformidadeStatus(
        apontamento.gemasDanificadasPragaClima,
        params.gemasDanificadasPragaClima,
    );

    if (_.isEmpty(params)) {
        return h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra)
                ),

                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                ),
            ],
            { widths: [60, "*"] },
        );
    }

    const content = [
        h.panel([h.row(h.title("Amostra"), h.text(nomeAmostra), h.title("Tipo"), h.textField("tipo"))], {
            widths: [60, "*", 60, 70],
        }),

        (() => {
            const titleAr = [h.title("Talhão"), h.title("Área (ha)")];
            const valueAr = [h.text(getTalhaoNomeDisplay(apontamento)), h.text(getTalhaoAreaDisplay(apontamento))];
            const tamAr = ["*", "*"];

            if (apontamento.variedade) {
                titleAr.push(h.title("Variedade"));
                valueAr.push(h.textField("variedade.variedade"));
                tamAr.push("*");
            }

            if (apontamento.corte) {
                titleAr.push(h.title("Corte"));
                valueAr.push(h.textField("corte"));
                tamAr.push("*");
            }

            titleAr.push(h.title("Frota"), h.title("Frente"), h.title("Turno"));
            valueAr.push(h.textField("trator.numeroFrotaTrator"), h.textField("frente"), h.textField("turno"));
            tamAr.push("*", "*", "*");

            return h.panel([h.row(titleAr), h.row(valueAr)], { widths: tamAr });
        })(),

        h.panel([
            // prettier-ignore
            h.row(
                h.title("COLETAS")
            ),
        ]),

        h.panel([h.row(h.title("Observação"), h.text(params.obs))], { widths: [60, "*"] }),

        h.panel(
            [
                h.row(h.title("Parametros"), h.title("Avaliado"), h.title("Conforme"), h.title("%")),

                h.row(
                    h.text("Desponte (perdas)"),
                    h.text(apontamento.totalAvaliadoDespontePerdas),
                    h.text(apontamento.totalConformeDespontePerdas),
                    h.conformidadeField("despontePerdas", statusDespontePerdas, { alignment: "left" }),
                ),

                h.row(
                    h.text("Desponte (Não Despontada)"),
                    h.text(apontamento.totalAvaliadoDesponteNaoDespontada),
                    h.text(apontamento.totalConformeDesponteNaoDespontada),
                    h.conformidadeField("desponteNaoDespontada", statusDesponteNaoDespontada, { alignment: "left" }),
                ),

                h.row(
                    h.text("Gemas Danificadas (Facão)"),
                    h.text(apontamento.totalAvaliadoGemasDanificadasFacao),
                    h.text(apontamento.totalConformeGemasDanificadasFacao),
                    h.conformidadeField("gemasDanificadasFacao", statusGemasDanificadasFacao, { alignment: "left" }),
                ),

                h.row(
                    h.text("Gemas Danificadas (Praga e Clima)"),
                    h.text(apontamento.totalAvaliadoGemasDanificadasPragaClima),
                    h.text(apontamento.totalConformeGemasDanificadasPragaClima),
                    h.conformidadeField("gemasDanificadasPragaClima", statusGemasDanificadasPragaClima, {
                        alignment: "left",
                    }),
                ),
            ],
            { widths: [200, 105, 105, 107, "*"] },
        ),
    ];

    return h.unbreakable(content);
}
